// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1DZYT","inputWrap":"styles_inputWrap__3WrHY","input":"styles_input__RmjVS"};